import { ExportStatus } from 'core/constants/report';
import { RelativeDateRanges } from 'core/constants/date';
import { ArchivalRequestMode, IArchivalNamespace } from 'core/models/archival';

/**
 * Namespaces archival is offered for.
 *
 * Hardcoded on purpose: archival does not read namespace config, and what makes a
 * namespace archival-eligible is still an open product decision, so there is
 * nothing to derive this from yet.
 *
 * Only Lead, Activity and Opportunity are here because the engine's
 * EntityTableSet returns an empty table set for anything else - offering Task or
 * Accounts would let a user pick something that comes back 400 on create.
 *
 * `Namespace` goes on the wire as `namespace` and `Type` as `namespaceType`. The
 * namespace name itself is not validated by the API (the worker resolves it), so
 * a wrong string here fails at dispatch time rather than on submit.
 */
export const archivalNamespaces: Array<IArchivalNamespace> = [
  { Namespace: 'leads', DisplayName: 'Lead', Type: 'Lead' },
  { Namespace: 'activities', DisplayName: 'Activities', Type: 'Activity' },
  { Namespace: 'opportunities', DisplayName: 'Opportunity', Type: 'Opportunity' },
];

// Default window offered when the user switches to a custom period, in days.
export const defaultRangeInDays = 30;

// Archived data only ever lies in the past, so the generic date filter options
// (which include Tomorrow / Next Week / ...) are not reused here. Custom Range
// swaps the dropdown for an explicit from - to pair.
export const archivalDurationOptions = [
  { label: 'Last 1 month', value: RelativeDateRanges.LastMonth },
  { label: 'Last 3 months', value: RelativeDateRanges.LastNintyDays },
  { label: 'Last 6 months', value: RelativeDateRanges.LastOneEightyDays },
  { label: 'Last 1 year', value: RelativeDateRanges.LastOneYear },
  { label: 'Last 2 years', value: RelativeDateRanges.LastTwoYear },
  { label: 'Custom range', value: RelativeDateRanges.Custom },
];

export const archivalModeOptions = [
  { label: 'Keep this period, archive the rest', value: ArchivalRequestMode.Keep },
  { label: 'Archive this period', value: ArchivalRequestMode.Archive },
];

export const archivalModeLabel: Record<string, string> = {
  [ArchivalRequestMode.Keep]: 'Keep',
  [ArchivalRequestMode.Archive]: 'Archive',
};

export const archivalStatusLabel: Record<string, string> = {
  [ExportStatus.InQueue]: 'In Queue',
  [ExportStatus.InProgress]: 'In Progress',
  [ExportStatus.Success]: 'Completed',
  [ExportStatus.Failed]: 'Failed',
};

export const archivalStatusClassName: Record<string, string> = {
  [ExportStatus.InQueue]: 'se-status-queued',
  [ExportStatus.InProgress]: 'se-status-progress',
  [ExportStatus.Success]: 'se-status-success',
  [ExportStatus.Failed]: 'se-status-failed',
};

export const PendoClassNames = {
  ArchivalTab: 'se-pendo-archival-tab',
  ArchivalCreateRequest: 'se-pendo-archival-create-request',
  ArchivalSearch: 'se-pendo-archival-search',
  ArchivalExport: 'se-pendo-archival-export',
  ArchivalRefresh: 'se-pendo-archival-refresh',
};
